export default "__VITE_ASSET__CbZDS1A___"